import { has } from 'underscore';
import { DistributionAccountStatsApiModel } from '../../../../api/distributions/model/distribution-account-stats.api.model';
import { AgprMath } from '../../../Misc/helpers/math/math-helper';

export class DistributionAccountStatisticsModel {
    sentDistributionsCount: number;
    sentRecipientsCount: number;
    deliveredCount: number;
    opensCount: number;
    uniqueOpensCount: number;
    clicksCount: number;
    uniqueClicksCount: number;
    uniqueBounces: number;
    unsubsCount: number;
    uniqueUnsubsCount: number;
    spamCount: number;
    uniqueSpamCount: number;
    replyCount: number;

    mppAdjustedUniqueOpenRate: number;
    estimatedActualOpens: number;
    reliableOpens: number;
    mppDeliveredCount: number;
    mppOpensCount: number;
    reliableDeliveredCount: number;
    reliableUniqueOpensCount: number;
    reliableUniqueOpenRate: number;
    reliableOpenRate: number;

    deliveryRate: number;
    uniqueOpenRate: number;
    uniqueClickRate: number;
    replyRate: number;
    bounceRate: number;
    unsubscribeRate: number;
    spamRate: number;

    constructor(apiModel: DistributionAccountStatsApiModel) {
        this.sentDistributionsCount = apiModel.sentDistributionsCount;
        this.sentRecipientsCount = apiModel.sentRecipientsCount;
        this.deliveredCount = apiModel.deliveredCount;
        this.opensCount = apiModel.opensCount;
        this.uniqueOpensCount = apiModel.uniqueOpensCount;
        this.clicksCount = apiModel.clicksCount;
        this.uniqueClicksCount = apiModel.uniqueClicksCount;
        this.uniqueBounces = apiModel.uniqueBounces;
        this.unsubsCount = apiModel.unsubsCount;
        this.uniqueUnsubsCount = apiModel.uniqueUnsubsCount;
        this.spamCount = apiModel.spamCount;
        this.uniqueSpamCount = apiModel.uniqueSpamCount;
        this.replyCount = apiModel.replyCount;

        this.mppOpensCount = apiModel.mppOpensCount;
        this.reliableUniqueOpensCount = apiModel.reliableUniqueOpensCount;
        this.mppDeliveredCount = apiModel.mppDeliveredCount;
        this.reliableDeliveredCount = apiModel.reliableDeliveredCount;

        this.reliableUniqueOpenRate = this.reliableUniqueOpensCount / this.sentRecipientsCount || 0;

        if (has(apiModel, 'mppOpensCount') && has(apiModel, 'reliableUniqueOpensCount')) {
            this.uniqueOpensCount = this.mppOpensCount + this.reliableUniqueOpensCount;
            this.reliableOpens = this.opensCount - this.mppOpensCount;
            this.estimatedActualOpens = Math.round((this.reliableUniqueOpenRate) * this.mppOpensCount + this.reliableOpens);
        }
        if (has(apiModel, 'mppDeliveredCount') && has(apiModel, 'reliableDeliveredCount')) {
            this.deliveredCount = this.mppDeliveredCount + this.reliableDeliveredCount;
        }

        this.reliableOpenRate = AgprMath.safeDivide(this.opensCount, this.deliveredCount) * 100;
        this.deliveryRate = AgprMath.safeDivide(this.deliveredCount, this.sentRecipientsCount) * 100;
        this.uniqueOpenRate = AgprMath.safeDivide(this.uniqueOpensCount, this.deliveredCount) * 100;

        const adjustedUniqueOpens = Math.round(this.reliableUniqueOpenRate * this.mppOpensCount) + this.uniqueOpensCount;
        this.mppAdjustedUniqueOpenRate = AgprMath.safeDivide(adjustedUniqueOpens, this.deliveredCount) * 100;

        this.uniqueClickRate = AgprMath.safeDivide(this.uniqueClicksCount, this.deliveredCount) * 100;
        this.bounceRate = AgprMath.safeDivide(this.uniqueBounces, this.sentRecipientsCount) * 100;
        this.unsubscribeRate = AgprMath.safeDivide(this.uniqueUnsubsCount, this.sentRecipientsCount) * 100;
        this.spamRate = AgprMath.safeDivide(this.uniqueSpamCount, this.sentRecipientsCount) * 100;
        this.replyRate = AgprMath.safeDivide(this.replyCount, this.sentRecipientsCount) * 100;
    }
}
